import { CAUI } from 'ca-ui';
import { VREditorSubPanel } from './subpanel.js';

export class VREditorPeoplePanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'people',
      name: 'People',
      instructions: 'Select a person to edit, or add a new person.',
      preview: true,
      assets: vr.assets.people,
      assetSelectLabel: 'Person',
      addApplyAssetButton: true,
      addApplyAssetMessage: '',
      allowAddAsset: true,
      addAssetButtonLabel: 'New Person',
      onAssetSwitch: function (asset) {
        console.log('on asset switch');
        if (this.getObject()) {
          this.getObject().setAsset(asset);
          if (this.selected.asset.frames !== undefined) {
            this.rotationSlider.prop('max', this.selected.asset.frames);
          } else {
            this.rotationSlider.prop('max', 7);
          }
        }
      },
      onAssetChange: function (asset) {
        if (this.getObject()) this.getObject().setAsset(asset);
        this.preview.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_' +
            asset.id +
            '_day_' +
            CAUI.zeroPad(this.rotationSlider.val(), 2) +
            '.png'
        );
      },
      onCreateAssetItem: function (item, asset) {
        item.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_' +
            asset.id +
            '_day_' +
            CAUI.zeroPad(
              this.rotationSlider ? this.rotationSlider.val() : 0,
              2
            ) +
            '.png'
        );
      }
    });
  }

  initControls () {
    // Rotation
    this.rotationLabel = $('<label style="margin-top:20px">Rotation</label>');
    this.rotationLabel.hide();
    super.append(this.rotationLabel);
    this.rotationSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="0" max="7" value="0"></input>'
    );
    this.rotationSlider.hide();
    super.append(this.rotationSlider);

    this.rotationSlider.on(
      'input',
      function () {
        this.selected.setRotation(this.rotationSlider.val());
        this.updatePreview();
      }.bind(this)
    );

    // Say
    // this.sayLabel = $('<label style="margin-top:20px">Say</label>');
    // this.sayLabel.hide();
    // super.append(this.sayLabel);

    // this.sayTextbox = $('<input type="input" maxlength="100" />');
    // this.sayTextbox.hide();
    // this.sayTextbox.on(
    //   'input',
    //   function () {
    //     this.selected.setTooltipText(this.sayTextbox.val());
    //   }.bind(this)
    // );
    // super.append(this.sayTextbox);
  }

  newObject () {
    return this.vr.addPerson();
  }

  setObject (obj, fireAssetChange) {
    super.setObject(obj, fireAssetChange);

    if (obj) {
      // this.sayLabel.show();
      // this.sayTextbox.show();
      // this.sayTextbox.val(obj.getTooltipText());
      if (fireAssetChange !== false) { this.assetSelect.val(obj.getPropId()).trigger('change'); }
      this.rotationLabel.show();
      this.rotationSlider.show();
      this.rotationSlider.val(obj.getRotation());
      this.updatePreview();
    } else {
      // this.sayLabel.hide();
      // this.sayTextbox.hide();
      this.rotationLabel.hide();
      this.rotationSlider.hide();
    }
  }

  // override
  openPanel(){}
}
